import { useContext, useRef, useState } from 'react';
import { Button, ButtonGroup, ClickAwayListener, Grow, List, Popper } from '@mui/material';
import { IconFilter } from '../icons/IconFilter';
import { ThemeContext } from '@f_context/Theme_context';
import { useTranslation } from 'react-i18next';

import stls from '@f_qwep/styles/component/orders/Orders.module.sass';
import { OrdersPanel } from './OrdersPanel';
import { FilterContext } from '@f_qwep/context/Filter_context';
import { OrdersContext } from '@f_qwep/context/Orders_context';

export function MobileButtonOrder({ items }: any) {
    const { t } = useTranslation();
    const { colors } = useContext(ThemeContext);
    const { filterOrder } = useContext(FilterContext);
    const { open, setOpen } = useContext(OrdersContext);

    const anchorRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen: any) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        setOpen(false);
    };

    const getSumFilters = () => {
        let count = 0;
        for (let key in filterOrder) {
            if (Array.isArray(filterOrder[key])) {
                count += filterOrder[key].length;
            }
        }
        return count;
    };

    return (
        <ButtonGroup variant="outlined" ref={anchorRef}>
            <Button
                id="mobileButtonOrder"
                sx={{ fontSize: '14px' }}
                aria-controls={open ? 'split-button-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                onClick={handleToggle}>
                {t('qwep.orders.filters')}
                <IconFilter />
                {getSumFilters() !== 0 && (
                    <sub style={{ color: colors.gamma, marginTop: '-15px' }}>{getSumFilters()}</sub>
                )}
            </Button>
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition className={stls.popperList}>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}>
                        <List sx={{ background: colors.psi }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <OrdersPanel items={items} />
                            </ClickAwayListener>
                        </List>
                    </Grow>
                )}
            </Popper>
        </ButtonGroup>
    );
}
